import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { isUserLoggedInSelector } from '../../store/App/selectors';
import IntegrationPageSectionProvider from './StateManagement/IntegrationPageSectionProvider';
import PageSectionWrapper from './PageSectionWrapper';
import SectionContent from './SectionContent';
import TestPanelProvider from './StateManagement/TestPanelProvider';

export default function IntegrationPageSection({
  ecmContent,
  serviceData = {},
  pageMetaDataConfig
}) {
  const { product } = useParams();

  const { sdkBaseUrl } = useMemo(() => ecmContent?.metadata || {}, [ecmContent]);
  const isUserLoggedIn = useSelector(isUserLoggedInSelector);
  if (!ecmContent) {
    return <></>;
  }

  return (
    <IntegrationPageSectionProvider
      ecmContent={ecmContent}
      serviceData={serviceData}
      sdkBaseUrl={sdkBaseUrl}
      pageMetaDataConfig={pageMetaDataConfig}
      isUserLoggedIn={isUserLoggedIn}
    >
      <TestPanelProvider>
        {product === 'fastlane' ? (
          <SectionContent ecmIntegContent={ecmContent} />
        ) : (
          <PageSectionWrapper ecmIntegContent={ecmContent} />
        )}
      </TestPanelProvider>
    </IntegrationPageSectionProvider>
  );
}

IntegrationPageSection.propTypes = {
  ecmContent: PropTypes.object.isRequired,
  serviceData: PropTypes.object.isRequired,
  pageMetaDataConfig: PropTypes.object.isRequired
};
